<template>
  <section class="single-car-comparison-component grid" :class="classes">
    <div class="shortlist-items">

      <comparison-grid-large-with-configuration
        v-if="hasInlineConfiguration"
        :panel="panel"
        :adminPortalData="adminPortalData"
        :quote="currentVisibleQuote"
        :sideBySide="sideBySide"
        :quoteExpired="quoteExpired"
        :refreshJaamaQuote="refreshJaamaQuote"
        :shortlist="shortlist"
        :session="session"
        :classes="classes"
        :selectedQuote="selectedQuote"
        :viewPreviousQuoteGroup="viewPreviousQuoteGroup"
        :viewNextQuoteGroup="viewNextQuoteGroup"
        :currentQuoteGroup="currentQuoteGroup"
        :activeQuoteInGroup="activeQuoteInGroup"
        :costsForSalarySacrificeQuote="costsForSalarySacrificeQuote"
        :averagePencePerMile="averagePencePerMile"
        :totalEstimatedElectricCostPerMonth="totalEstimatedElectricCostPerMonth"
        :remove="remove"
        :viewQuoteInGroup="viewQuoteInGroup"
        :selectQuote="selectQuote"
        :saveConfigurationInline="saveConfigurationInline"
        :driverGradesById="driverGradesById"
        v-on:select-quote="updateSelectedQuote($event)"
        @quote-removed="viewPreviousQuoteGroup"
      ></comparison-grid-large-with-configuration>

      <comparison-grid-large
        v-else
        :panel="panel"
        :adminPortalData="adminPortalData"
        :quote="currentVisibleQuote"
        :sideBySide="sideBySide"
        :quoteExpired="quoteExpired"
        :refreshJaamaQuote="refreshJaamaQuote"
        :shortlist="shortlist"
        :session="session"
        :classes="classes"
        :selectedQuote="selectedQuote"
        :viewPreviousQuoteGroup="viewPreviousQuoteGroup"
        :viewNextQuoteGroup="viewNextQuoteGroup"
        :currentQuoteGroup="currentQuoteGroup"
        :activeQuoteInGroup="activeQuoteInGroup"
        :costsForSalarySacrificeQuote="costsForSalarySacrificeQuote"
        :averagePencePerMile="averagePencePerMile"
        :totalEstimatedElectricCostPerMonth="totalEstimatedElectricCostPerMonth"
        :remove="remove"
        :viewQuoteInGroup="viewQuoteInGroup"
        :selectQuote="selectQuote"
        :driverGradesById="driverGradesById"
        v-on:select-quote="updateSelectedQuote($event)"
        @quote-removed="viewPreviousQuoteGroup"
      />

    </div>
  </section>
</template>

<script>
import {EventBus} from "@/event-bus";
import ComparisonGridLarge from "@/components/car-comparison/comparison-grid-large";
import ComparisonGridLargeWithConfiguration from "@/components/car-comparison/with-configuration/comparison-grid-large";
import {useRoute} from "vue-router";

export default {
  name: "comparison-grid",
  components: {EventBus, ComparisonGridLarge, ComparisonGridLargeWithConfiguration},
  props: [
    'adminPortalData',
    'panel',
    'session',
    'sideBySide',
    'shortlist',
    'classes',
    'currentVisibleQuote',
    'quoteExpired',
    'viewPreviousQuoteGroup',
    'viewNextQuoteGroup',
    'selectedQuote',
    'currentQuoteGroup',
    'activeQuoteInGroup',
    'costsForSalarySacrificeQuote',
    'averagePencePerMile',
    'totalEstimatedElectricCostPerMonth',
    'saveConfigurationInline',
    'hasInlineConfiguration',
    'driverGradesById',
  ],

  setup() {
    const route = useRoute();
    return { route }
  },

  methods: {
    refreshJaamaQuote(quoteId) {
      EventBus.$emit('loadingTitle', 'Refreshing Quote');
      EventBus.$emit('loading', true);

      this.$http.post('/api/quote/' + quoteId + '/refresh', {
        shortlistId: this.shortlist.shortListID,
      }).then(response => {
        this.$router.go()
      }).catch(err => {
        EventBus.$emit('loading', false);
        Vue.notify({
          group: 'notify',
          type: 'error',
          title: 'Error',
          text: response.message
        });
      });
    },

    viewQuoteInGroup(panel, index) {
      EventBus.$emit('view-quote-in-group', panel, index);
    },

    selectQuote(type, item) {
      this.$emit('select-quote', {
        quote: item,
        quoteID: item.quoteID,
        quoteName: item.quote.definition.quoteName,
        type: type,
        scheme: this.route.params.scheme,
      });
    },

    updateSelectedQuote(event) {
      // Pass down the chain
      this.$emit('select-quote', event);
    },

    remove(quote) {
      const shortListID = this.shortlist.shortListID;
      const quoteID = quote.quoteID;

      EventBus.$emit('loadingTitle', 'Removing Vehicle from Shortlist');
      EventBus.$emit('loading', true);

      this.$http.post('/api/quotation', {
        method: 'DELETE',
        endpoint: 'shortlists/' + shortListID + '/quotes/' + quoteID,
      })
        .then(response => {

          EventBus.$emit('loading', false);

          if (Number(response.data.status) === 200) {

            this.$notify({
              group: 'notify',
              type: 'success',
              title: quote.manufacturerName + ' ' + quote.modelName,
              text: 'Has been removed from your comparison shortlist'
            })

            this.$emit('quote-removed');

            if (this.shortlist.quotes.length === 0) {
              this.$router.push('/origo-retail');
            }

            this.$router.go()

          } else {

            this.$notify({
              group: 'notify',
              type: 'error',
              title: 'Error',
              text: response.data.message
            })

            for (let property in response.data.errors) {
              if (response.data.errors.hasOwnProperty(property)) {
                response.data.errors[property].forEach((error) => {
                  this.$notify({
                    group: 'notify',
                    type: 'error',
                    title: 'Error',
                    text: error
                  })
                });
              }
            }

          }
        })
        .catch(err => {
          EventBus.$emit('loading', false);
          this.$notify({
            group: 'notify',
            type: 'error',
            title: 'Error',
            text: err.toString()
          })
          this.error = err.toString()
        });
    },
  }

}
</script>
